module.exports = __webpack_public_path__ + "static/img/app_bg1.d22e4768.png";